import type { AlertTask } from '@/alerts/entities/task';
import type { ListAlertsViewTaskPreview } from '@/api/fe-api/__generated__/oazapfts-client';
import { TaskPriority } from '@/task-manager/entities/task-priority';
import { TaskStatus } from '@/task-manager/entities/task-status';

export function taskMapper(data: ListAlertsViewTaskPreview): AlertTask {
  return {
    id: data.uuid,
    title: data.title,
    subtitle: data.subtitle || '',
    status: data.status as TaskStatus,
    priority: data.priority as TaskPriority,
  };
}
